
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rivals",
      function () {
        return require("private-next-pages/rivals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rivals"])
      });
    }
  